import React from "react";
import Grid from "@material-ui/core/Grid";
import UserRequestCard from "./user_request_card";
import ToolsButton from "../../components/tools_button.component";

const UserRequestCardList = ({ requests }) => {
  return (
    <div className="main-reqlist-container">
      <Grid item>
        {requests &&
          requests.map((req) => <UserRequestCard key={req.id} request={req} />)}
      </Grid>
      <div className="new-icon">
        <ToolsButton
          context_type="Admin"
          context_id="me"
          showNavigation
          hideBookcalls
        />
      </div>
    </div>
  );
};

export default UserRequestCardList;
